const getters = {
	sidebar: state => state.app.sidebar,
	token: state => state.user.token,
	avatar: state => state.user.avatar,
	user: state => state.user.info,
	company: state => state.user.company,
	roles: state => state.user.roles,
	routes: state => state.user.routes,
	currentRoutes: state => state.user.currentRoutes
}
export default getters
